// extracted by mini-css-extract-plugin
export var avatarContainer = "_3h-1";
export var largeAvatarContainer = "_3h-2";
export var smallAvatarContainer = "_3h-0";